/* eslint-disable react/forbid-prop-types */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/**
 * @name DateRangePicker
 * @author Shalini Jha
 * @desc Date Range Picker using react-date-range
 * https://github.com/Adphorus/react-date-range#readme
 */
import React from 'react';
import { DateRange } from 'react-date-range';
import moment from 'moment';
import PropTypes from 'prop-types';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import 'react-date-range/dist/styles.css'; // main css file

import 'react-date-range/dist/theme/default.css'; // theme css file

import styles from './DateRangePicker.module.css';
import './DateRangePicker.css';
const { CardContent } = MaterialUiCore;
const { Card } = MaterialUiCore;
const DATE_SELECTION_CATEGORIES = {
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_7_DAYS: 'Last 7 Days',
    LAST_30_DAYS: 'Last 30 Days',
    LAST_MONTH: 'Last Month',
    THIS_MONTH: 'This Month',
    NEXT_MONTH: 'Next Month',
};
/**
 * @name selectDateRange
 * @desc Selects the date range for the default date selectors
 * as mentioned in the DATE_SELECTION_CATEGORIES constant
 * @param {Int} category
 * @param {Func} setDateRange
 * @param {Func} onChangeHandler
 */

export const selectDateRange = (category, setDateRange, onChangeHandler, setSelectedChip) => {
    let startDate = null;
    let endDate = null;
    const date = new Date();

    switch (category) {
        case DATE_SELECTION_CATEGORIES.TODAY:
            startDate = new Date();
            endDate = new Date();
            break;

        case DATE_SELECTION_CATEGORIES.YESTERDAY:
            startDate = new Date(moment().subtract(1, 'days'));
            endDate = new Date(moment().subtract(1, 'days'));
            break;

        case DATE_SELECTION_CATEGORIES.LAST_7_DAYS:
            startDate = new Date(moment().subtract(6, 'days'));
            endDate = new Date();
            break;

        case DATE_SELECTION_CATEGORIES.LAST_30_DAYS:
            startDate = new Date(moment().subtract(29, 'days'));
            endDate = new Date();
            break;

        case DATE_SELECTION_CATEGORIES.LAST_MONTH:
            startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            endDate = new Date(date.getFullYear(), date.getMonth(), 0);
            break;

        case DATE_SELECTION_CATEGORIES.THIS_MONTH:
            startDate = new Date(date.getFullYear(), date.getMonth(), 1);
            endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            break;

        case DATE_SELECTION_CATEGORIES.NEXT_MONTH:
            startDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            endDate = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            break;

        default:
            startDate = new Date();
            endDate = new Date();
    }

    setDateRange([
        {
            startDate,
            endDate,
            key: 'selection',
        },
    ]);
    onChangeHandler(startDate, endDate);
    setSelectedChip(category);
};

const DateRangePickerComponent = ({
    startDate,
    endDate,
    onChangeHandler,
    open,
    handleClose,
    reset,
    setReset,
    hideNextMonthCategory,
}) => {
    const [dateRange, setDateRange] = React.useState([
        {
            startDate: startDate || new Date(),
            endDate: endDate || new Date(),
            key: 'selection',
        },
    ]);
    const [selectedChip, setSelectedChip] = React.useState(null);
    /**
     * @name onChange
     * @desc Handles the on change event of the date picker
     * @param {*} item
     */

    const onChange =
        /* istanbul ignore next */
        (item) => {
            setDateRange([item.selection]);
            onChangeHandler(item.selection.startDate, item.selection.endDate);
            setSelectedChip(null);
        };

    React.useEffect(() => {
        if (reset) {
            setDateRange([
                {
                    startDate: startDate || new Date(),
                    endDate: startDate || new Date(),
                    key: 'selection',
                },
            ]);
            setSelectedChip(null);
            setReset(false);
        }
    }, [reset]);

    return (
        <div className={styles.DRP_Container}>
            <button
                id="date-picker-btn"
                className={styles.DRP_TextBox}
                type="button"
                onClick={() => handleClose(!open)}
            >
                <span>
                    {moment(dateRange[0].startDate).format('DD MMM YYYY')} -{' '}
                    {moment(dateRange[0].endDate).format('DD MMM YYYY')}
                </span>
                <span className="sct-icon icon-Calendar-18" />
            </button>
            {open && (
                <Card className={styles.DRP_Wrapper}>
                    <CardContent>
                        <div className={styles.DRP_Actions}>
                            <span className="sct-icon icon-Remove-18" onClick={() => handleClose(false)} />
                        </div>
                        <div className={styles.DRP_DefaultDateSelectors}>
                            {(!hideNextMonthCategory
                                ? Object.keys(DATE_SELECTION_CATEGORIES)
                                : Object.keys(DATE_SELECTION_CATEGORIES).filter((label) => label !== 'NEXT_MONTH')
                            ).map((label) => (
                                <button
                                    type="button"
                                    key={DATE_SELECTION_CATEGORIES[label]}
                                    onClick={
                                        /* istanbul ignore next */
                                        () =>
                                            selectDateRange(
                                                DATE_SELECTION_CATEGORIES[label],
                                                setDateRange,
                                                onChangeHandler,
                                                setSelectedChip,
                                            )
                                    }
                                    className={`chip ${
                                        selectedChip === DATE_SELECTION_CATEGORIES[label] ? 'chipActive' : ''
                                    }`}
                                >
                                    {DATE_SELECTION_CATEGORIES[label]}
                                </button>
                            ))}
                        </div>
                        <DateRange
                            onChange={onChange}
                            showSelectionPreview
                            moveRangeOnFirstSelection={false}
                            months={2}
                            ranges={dateRange}
                            direction="horizontal"
                            editableDateInputs
                            className="DRP_OverwriteStyles"
                            showMonthAndYearPickers
                            rangeColors={['#cb2c90']}
                            startDatePlaceholder="From"
                            endDatePlaceholder="To"
                        />
                    </CardContent>
                </Card>
            )}
        </div>
    );
};

DateRangePickerComponent.propTypes = {
    startDate: PropTypes.any.isRequired,
    endDate: PropTypes.any.isRequired,
    onChangeHandler: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
};
export default DateRangePickerComponent;
